(() => {
  const parseFitMap = (mapEl) => {
    if (!mapEl) return { ids: {}, names: {} };

    try {
      const parsed = JSON.parse(mapEl.textContent || '{}');

      if (parsed.ids || parsed.names) {
        return { ids: parsed.ids || {}, names: parsed.names || {} };
      }

      return { ids: parsed, names: {} };
    } catch {
      return { ids: {}, names: {} };
    }
  };

  const getOptionLabel = (input, root) => {
    if (!input?.id) return '';

    const label = root.querySelector(`label[for="${CSS.escape(input.id)}"]`);

    return label?.textContent?.replace(/\s+/g, ' ').trim() || '';
  };

  const resolveFitText = (root, fitMap, checkedInput) => {
    if (!checkedInput) return '';

    const byId = fitMap.ids[String(checkedInput.value)];
    if (byId) return byId;

    const byName = fitMap.names[getOptionLabel(checkedInput, root)];
    if (byName) return byName;

    return fitMap.ids[checkedInput.value] || '';
  };

  const updateFitText = (root) => {
    const fitEl = root.querySelector('[data-td-armband-fit]');
    const mapEl = root.querySelector('[data-td-armband-fit-map]');

    if (!fitEl || !mapEl) return;

    const fitMap = parseFitMap(mapEl);
    const checkedInput = root.querySelector('input[data-option-position]:checked');

    if (!checkedInput) return;

    const fitText = resolveFitText(root, fitMap, checkedInput);

    if (fitText) {
      fitEl.textContent = fitText;
      fitEl.hidden = false;
    } else if (!fitEl.textContent.trim()) {
      fitEl.hidden = true;
    }

    fitEl.dataset.activeOptionValueId = checkedInput.value;
  };

  const updateAll = () => {
    document.querySelectorAll('[data-td-armband-size]').forEach(updateFitText);
  };

  const init = () => {
    updateAll();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  document.addEventListener(
    'change',
    (event) => {
      if (!event.target.matches('input[data-option-position]')) return;

      const root = event.target.closest('[data-td-armband-size]');

      if (root) updateFitText(root);
    },
    true
  );

  document.addEventListener('variant:change', () => {
    requestAnimationFrame(updateAll);
  });

  document.addEventListener(
    'product:rerender',
    () => {
      requestAnimationFrame(updateAll);
    },
    true
  );
})();
